// Catálogo de cirugías oftalmológicas más frecuentes en FOCA.
// El input es un combobox (datalist) — permite escribir libre si aparece
// una cirugía no listada, pero incentiva usar los términos estándar
// para que los indicadores /indicadores agrupen correctamente.

export const CIRUGIAS_COMUNES: string[] = [
  "Catarata OD",
  "Catarata OI",
  "Catarata bilateral",
  "Facoemulsificación OD",
  "Facoemulsificación OI",
  "Implante lente intraocular OD",
  "Implante lente intraocular OI",
  "Vitrectomía OD",
  "Vitrectomía OI",
  "Vitrectomía posterior con endoláser",
  "Trabeculectomía OD",
  "Trabeculectomía OI",
  "Válvula de Ahmed OD",
  "Válvula de Ahmed OI",
  "Iridotomía láser OD",
  "Iridotomía láser OI",
  "Pterigión OD",
  "Pterigión OI",
  "Estrabismo — corrección quirúrgica",
  "Ptosis palpebral",
  "Chalazión — resección",
  "Dacriocistorrinostomía",
  "Queratoplastia penetrante OD",
  "Queratoplastia penetrante OI",
  "Cross-linking corneal",
  "Cirugía refractiva LASIK",
  "Cirugía refractiva PRK",
  "Enucleación",
  "Evisceración",
  "Retinopexia neumática",
  "Cerclaje escleral",
  "Otro (especificar en observaciones)",
];
